import React from "react";

// Create a context for the print function
export const PrintContext = React.createContext();

// Custom hook to use the print function
export const usePrint = () => {
  const context = React.useContext(PrintContext);
  if (context === undefined) {
    throw new Error("usePrint must be used within a PrintableArea");
  }
  return context;
};
